export function mapPriceTableOption(item) {
  const rawCod = item?.CodTabelaPreco ?? item?.CodigoTabelaPreco ?? null;
  const cod = rawCod != null ? String(rawCod).trim() : "";
  const desc = (item?.Descricao ?? item?.Nome ?? "").trim();
  const displayLabel = desc ? `${cod} · ${desc}` : cod;
  return { ...item, CodTabelaPreco: cod, Descricao: desc, displayLabel };
}

export function formatDescontoExibicao(pct) {
  if (pct == null || pct === "") return "";
  const n = Number(pct);
  if (Number.isNaN(n)) return String(pct);
  return `${n.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;
}

export function mapPaymentOptionForSelect(item) {
  const { PercentualDesconto: _pct, ...rest } = item ?? {};
  const politica = rest.Politica?.trim() ?? "";
  const prazo =
    rest.PrazoMedio != null && rest.PrazoMedio !== ""
      ? `${rest.PrazoMedio} dias`
      : "";
  const displayLabel = prazo ? `${politica} · ${prazo}` : politica;
  return { ...rest, displayLabel };
}

export function buildPaymentEntryLabel(entry) {
  const politica = entry.Politica?.trim() ?? `Condição ${entry.IdCondicaoPagamento}`;
  const desconto = formatDescontoExibicao(entry.PercentualDesconto);
  return desconto ? `${politica} · Desconto: ${desconto}` : politica;
}

export function recalcMinimumInvoice(minimumValue, paymentConditions) {
  const list = Array.isArray(paymentConditions)
    ? paymentConditions
    : paymentConditions
      ? [paymentConditions]
      : [];
  const prazos = list
    .map((c) => Number(c?.PrazoMedio))
    .filter((p) => !Number.isNaN(p) && p > 0);
  const prazoNum = prazos.length > 0 ? Math.min(...prazos) : 0;
  if (!minimumValue || !prazoNum) return 0;
  return minimumValue / (prazoNum / 30 || 1);
}
